export const convertNullToUndefined = <TType>(value: TType | undefined | null): TType | undefined => {
  return value ?? undefined;
};
